export default "__VITE_ASSET__De$MZxno__"